
// Ajax cart JS for Drawer and Cart Page
const drawerSelectors = {
  cartIcons: document.querySelectorAll('.header__icon--cart'),
  cartIconDesktop: document.querySelector('#cart-icon-desktop'),
  cartIconMobile: document.querySelector('#cart-icon-mobile'),
};
class ajaxCart extends HTMLElement {
    constructor() {
      super();
  
      this.openeBy = drawerSelectors.cartIcons;
      this.isOpen =  this.classList.contains('open--drawer');
      this.bindEvents();
  
      if(window.globalVariables.template != 'cart'){
        this.addAccessibilityAttributes(this.openeBy);
        this.getCartData();
      }else{
        this.cartUpsell();
        this.style.visibility = 'visible';
      }
      if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
//       this.manageBoldCallback();
    }
  
    /**
     * Observe attribute of component
     * 
     * @returns {array} Attributes to Observe
     */
    static get observedAttributes() {
      return ['updating'];
    }
  
    /**
     * To Perform operation when attribute is changed
     * Calls attributeChangedCallback() with params when attribute value is updated
     * 
     * @param {string} name attribute name
     * @param {string} oldValue attribute Old value
     * @param {string} newValue attribute latest value
     */
    attributeChangedCallback(name, oldValue, newValue) {
      // called when one of attributes listed above is modified
      if(name == 'updating' && newValue == 'false'){
        this.updateEvents();
      }
    }
  
    /**
     * Add accessibility attributes to Open Drawer buttons
     * 
     * @param {Node Array} openDrawerButtons Cart Icons
     */
    addAccessibilityAttributes(openDrawerButtons) {
      let _this = this;
      openDrawerButtons.forEach(element => {
        element.setAttribute('role', 'button');
        element.setAttribute('aria-expanded', false);
        element.setAttribute('aria-controls', _this.id);
      });
    }
  
    /**
     * Escape Click event to close drawer when focused within Cart Drawer
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
      this.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
    }
  
    /**
     * bind dclick and keyup event to Cart Icons
     * bind keyUp event to Cart drawer component
     * bind Other inside element events
     *
     */
    bindEvents() {
      if(window.globalVariables.template != 'cart'){
        this.openeBy.forEach(cartBtn => cartBtn.addEventListener('click', this.openCartDrawer.bind(this)));
        this.addEventListener('keyup', this.onKeyUp.bind(this));
      }
      // this.updateEvents();
    }

    /**
     * bind Other inside element events to DOM
     *
     */
    updateEvents(){
      this.querySelectorAll('.close-ajax--cart').forEach(button => button.addEventListener('click', this.closeCartDrawer.bind(this)));
      this.querySelectorAll('[data-itemRemove]').forEach(button => button.addEventListener('click', this.removItem.bind(this)));
      this.querySelectorAll('[data-qty-btn]').forEach(button => button.addEventListener('click', this.manageQtyBtn.bind(this)));
      this.querySelectorAll('[data-qty-input]').forEach(button => button.addEventListener('click', this.onQtyChange.bind(this)));
      if(window.globalVariables.template == 'cart'){
        this.querySelectorAll('[data-modal-opener]').forEach(button => button.addEventListener('click', function() {
          var dialogInstance = document.querySelector('#'+button.getAttribute('data-modal-opener'));
          dialogInstance.show();
        }));
      }
    }
  
    /**
     * Open Cart drawer and add focus to drawer container
     *
     * @param {event} Event instance
     */ 
    openCartDrawer(event) {
      if(!window.globalVariables.cart_drawer){
        window.location.href = window.routes.cart_fetch_url || '/cart';
        return;
      }
  
      if(document.querySelector('#mobile-menu-drawer').classList.contains('opened-drawer')){
        document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
      }
  
      this.classList.add('opened-drawer');
      siteOverlay.prototype.showOverlay();
      Utility.forceFocus(this.querySelector('.cart-title'));
      let closeBtn = this.querySelector('.close-ajax--cart');
      Utility.trapFocus(this, closeBtn);
  
      if(event){
        event.preventDefault();
        let openBy = event.currentTarget;
        openBy.setAttribute('aria-expanded', true);
      }
      if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
        typeof BOLD.common.eventEmitter.emit === 'function'){
          BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
      }
    }
  
    /**
     * Close Cart drawer and Remove focus from drawer container
     *
     * @param {event} Event instance
     */
    closeCartDrawer(event, elementToFocus = false) {
      if (event !== undefined) {
        event.preventDefault();
        this.classList.remove('opened-drawer');
        siteOverlay.prototype.hideOverlay();
        let openByEle = event.currentTarget;
        openByEle.setAttribute('aria-expanded', false);
        Utility.removeTrapFocus(elementToFocus);
  
        let actionBtn = drawerSelectors.cartIconDesktop;
        if(window.innerWidth < 1024){
          actionBtn = drawerSelectors.cartIconMobile;
        }
        Utility.forceFocus(actionBtn);
      }
    }
  
    /**
     * Update cart HTML and Trigger Open Drawer event
     *
     * @param {string} cartHTML String formatted response from fetch cart.js call
     * @param {string} action Open Drawer as value if need to Open Cart drawer
     */
    _updateCart(response, action){
      this.setAttribute('updating', true);

      // Convert the HTML string into a document object
      let cartHTML = '';
      if(window.globalVariables.template != 'cart') {
        cartHTML = response['template-ajax-cart'];
      }else{
        cartHTML = response['template-cart'];
      }

      if(cartHTML == null) return;
      let parser = new DOMParser();
      cartHTML = parser.parseFromString(cartHTML, 'text/html');

      let cartJSONEle = cartHTML.querySelector('[data-cartScriptJSON]');
      if(cartJSONEle != undefined && cartJSONEle != null){
        window.globalVariables.cart = JSON.parse(cartJSONEle.textContent);
      }

      let cartElement = cartHTML.querySelector('ajax-cart');
      this.innerHTML = cartElement.innerHTML;
      this.setAttribute('updating', false);

      let headerHTML = new DOMParser().parseFromString(response['header'], 'text/html');
      let cartIcon = headerHTML.getElementById('cart-icon-desktop');
      if(drawerSelectors.cartIconDesktop) drawerSelectors.cartIconDesktop.innerHTML = cartIcon.innerHTML;
      if(drawerSelectors.cartIconMobile) drawerSelectors.cartIconMobile.innerHTML = cartIcon.innerHTML;

      if(window.globalVariables.cart_drawer == true && action == 'open_drawer' && window.globalVariables.template != 'cart'){
          this.openCartDrawer();
      }
      this.cartUpsell();

    }

    /**
     * Fetch latest cart data
     *
     * @param {string} action Open Drawer as value if need to Open Cart drawer or else let it be empty
     */
    getCartData(action){
      
        let fetchCart = fetch(`${routes.cart_fetch_url}?sections=template-cart,header`);
        if(window.globalVariables.template != 'cart') fetchCart = fetch(`${routes.cart_fetch_url}?sections=template-ajax-cart,header`);
        fetchCart.then(response => {
          return response.json();
        }).then(response => {
          this._updateCart(response, action);

          if(window.globalVariables.template == 'product'){
            let productVariants = document.querySelector('[data-type="variant-select"]');
            if(productVariants && productVariants.currentVariant_inventory){
              productVariants._inventoryLimit();
            }

          }

        }).catch((e) => {
            console.error(e);
        }).finally(() => {
            // Cart HTML fetch done
        });
    }

     /**
     * Update Quantity API call
     *
     * @param {string} line Line Index value of cart Item (Starts from 1)
     * @param {integer} quantity Quantity to update
     */
    updateItemQty(line, quantity){
      let lineItem = document.querySelectorAll('[data-cart-item]')[line-1];
      let properties_val = lineItem?.querySelector('ul.properties__text li > span');
    

      if(lineItem){ lineItem.classList.add('updating'); }
      const body = JSON.stringify({
          line,
          quantity
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body }})
      .then((response) => {
          return response.text();
      })
      .then((state) => {
        this.getCartData();
        setTimeout(() => {
          if(lineItem){ lineItem.classList.remove('updating'); }
        }, 1000);
        if(properties_val){
            let properies_text = properties_val.textContent;
            if(properies_text.indexOf("_bold") > -1){
              if(typeof updateBundleGetCart === "function"){
                updateBundleGetCart();
              }
            }
          }
      	
      }).catch((error) => {
        setTimeout(() => {
          if(lineItem){ lineItem.classList.remove('updating'); }
        }, 1000);
        console.log(error);
      });
    }

    /**
     * Remove Item Event
     *
     * @param {event} Event instance
     */
    removItem(event){
      event.preventDefault();
      let currentTarget = event.currentTarget;
      let itemIndex = currentTarget.dataset.index || null;
      if(itemIndex != null){
          this.updateItemQty(itemIndex, 0);
      }
    }

    /**
     * Cart Item Qunatity Increment/Decrement Button event
     *
     * @param {event} Event instance
     */
    manageQtyBtn(event){
      event.preventDefault();
      let currentTarget = event.currentTarget;
      let action = currentTarget.dataset.for || 'increase';
      let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
      let itemIndex = $qtyInput.dataset.index || 1;
      let currentQty = parseInt($qtyInput.value) || 1;
      let finalQty = 1;
      const $cartItem = currentTarget.closest("[data-cart-item]");
      const ballProperties = $cartItem.querySelector("ul.properties__text li > span");
      let cartProperties = '';

      if(ballProperties){
        cartProperties = ballProperties.textContent;
      }
      
      if(action == 'decrease' && currentQty <= 1){
          return false;
      }else if(action == 'decrease'){

        if(cartProperties.indexOf('Your Logo') > -1){
          if (currentQty > 24) {
            finalQty = currentQty - 1;
          }else{
            finalQty = 24;
          }
        }else {
          finalQty = currentQty - 1;
        }
      }else{
          finalQty = currentQty + 1;
      }
      this.updateItemQty(itemIndex, finalQty);
    }

    /**
     * Cart Item Qunatity Input change event
     *
     * @param {event} Event instance
     */
    onQtyChange(event){
      const $qtyInput = event.currentTarget;
      const qtyValue = $qtyInput.value;
      const itemIndex = $qtyInput.dataset.index || null;
      if(itemIndex) this.updateItemQty(itemIndex, qtyValue);
    }

    manageBoldCallback(){
      const form = document.querySelector('[data-cart-form]');
      if(form) {
        form.addEventListener('submit', (event) => {
          const formAction = form.getAttribute('action');
          if (formAction !== '/tools/shappify-pb/v2/create_draft_order') {
            return;
          }
          // disable default action
          event.preventDefault();

          let checkoutButton = document.querySelector('[name="checkout"]');
          var beforeSend = function(){
            checkoutButton.setAttribute('disabled', true);
            checkoutButton.textContent = 'Please Wait...';
          }

          // configure a request
          const xhr = new XMLHttpRequest();
          xhr.open('POST', formAction);

          // prepare form data
          let data = new FormData(form);
          
          let xhrData = [];
          for (var pair of data.entries()) {
            xhrData.push(`${pair[0]}=${pair[1]}`);
          }
          xhrData = xhrData.join('&');

          // set headers
          xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
          xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

          beforeSend();
          // send request
          xhr.send(xhrData);

          // listen for `load` event
          xhr.onload = () => {
            const response = xhr.responseText;
            const urls = response.match(/(https?:\/\/[^\s"']+)/gi);
            if(typeof urls[0] !== 'undefined') {
              handleCheckoutRedirect(urls[0]);
            }
          }

        });
        async function handleCheckoutRedirect(url, tries) {
          try {
            if (!tries) {
              tries = 0;
            }
            if(tries >= 3) {
              //show error message to customer.
              return
            }
            let response = await fetch(url, {redirect: 'manual'});
            if(response.status === 200 || response.type === 'opaqueredirect') {
              window.location.href = url;
              return;
            } else {
              setTimeout(function() {
                tries++;
                return handleCheckoutRedirect(url, tries);
              }, 1000);
            }
          } catch(error) {
            tries++;
            Rollbar.error('Bold callback error in handleCheckoutRedirect() function',error)
            return handleCheckoutRedirect(url, tries);
          }
        }

      }

    }

    cartUpsell() {
      const productsContainer = document.querySelector("[data-cart-form] .upsell_container");
      if (!window.globalVariables.enable_cart_upsell || window.globalVariables.upsell_collection == null || productsContainer == null) return;

      const $this = this;
      const upsellCollection = document.querySelector('[data-upsellProductScriptJSON]');
      let upsellCollectionJSON = "";
      let productListHTML = "";

      if(upsellCollection != undefined && upsellCollection != null){
        upsellCollectionJSON = JSON.parse(upsellCollection.textContent);
      }else{
        return;
      }
      const cartData = window.globalVariables.cart;
      const diffJSON = this._diff(upsellCollectionJSON.products, cartData.items);

        productListHTML = diffJSON.map(p => {
        let productDetailsJson = p.product;
        let optionSelect;
        if(productDetailsJson.variants[0].title != 'Default Title'){
          optionSelect = productDetailsJson.variants.map(variant => {
              if (variant.available) return `<option value="${variant.id}">${variant.title}</option>`;
          }).join("");
        }
        return `
            <div class="swiper-slide carousel-cell d-flex equal-height px-md-2 px-1">
              <div class="card card-product card-product-style-1 text-start border-gray-400 shadow-none" data-product-id="${productDetailsJson.id}">
                ${productDetailsJson.compare_at_price > productDetailsJson.price
                  ? `<span class="badges">
                          <span class="badge badge-warning">On Sale</span>
                      </span>`
                  : ``
                }
                <div class="upsell_product_image_container">
                  <a class="d-block pt-5 pt-md-3 px-3 upsell_product_url" href="products/${productDetailsJson.handle}" title="${productDetailsJson.title}">
                    <img class="upsell_product_image" width="250" height="250" src="${productDetailsJson.featured_image}&width=250" alt="${productDetailsJson.title}">
                  </a>
                </div>
                <div class="upsell_product_info card-body px-3 pt-2 pb-1">
                  <a class="upsell_product_url d-block" href="products/${productDetailsJson.handle}">${productDetailsJson.title}</a>
                  <div class="upsell_product_price">
                  ${productDetailsJson.compare_at_price > productDetailsJson.price
                    ? `<s class="upsell_productCompareAtPrice small m-0 p-0">${Shopify.formatMoney(productDetailsJson.compare_at_price, window.globalVariables.money_format)}</s>`
                    : ``
                  }
                  <span class="upsell_productRegularPrice">${Shopify.formatMoney(productDetailsJson.price, window.globalVariables.money_format)}</span>
                  </div>
                  ${
                      productDetailsJson.variants[0].title == 'Default Title' ? ''  :
                      `<div class="upsell_product_dropdown mt-3">
                          <select class="bg-gray-200 border-0 form-control form-select pe-4 ps-3 py-2 text-black text-uppercase upsell_variants variant_selector" aria-label="option" data-upsell-dropbox style="background-position: 94% 50%;" >
                              ${optionSelect}
                          </select>
                      </div>`
                  }
                </div>
                <div class="upsell_add_button card-footer bg-white border-top-0 px-3">
                  <button type="button" class="btn btn-primary btn-block" data-addproductid="${productDetailsJson.variants[0].id}" data-upsell-btn>ADD</button>
                </div>
              </div>
            </div>
          `;
      }).join('');

      let dataSliderOptions;
      if(window.globalVariables.template != 'cart'){

        dataSliderOptions = `
          <div class="swiper swiper-slider featured-collection-slider card-carousel" data-slider='{
            "loop": false,
            "slidesPerView": 2,
            "spaceBetween": 0,
            "freeMode": false,
            "allowTouchMove": true,
            "navigation": {
              "nextEl": ".upsell-swiper-button-next",
              "prevEl": ".upsell-swiper-button-prev"
            }
          }'>
            <div class="swiper-wrapper">
              ${productListHTML}
            </div>
        </div>`;

      }else{

        dataSliderOptions = `
          <div class="swiper swiper-slider featured-collection-slider card-carousel" data-slider='{
            "loop": false,
            "slidesPerView": 2,
            "spaceBetween": 0,
            "freeMode": false,
            "allowTouchMove": true,
            "navigation": {
              "nextEl": ".upsell-swiper-button-next",
              "prevEl": ".upsell-swiper-button-prev"
            },
            "breakpoints": {
              "768": {
                "allowTouchMove": false,
                "slidesPerView": 3
              },
              "992": {
                "allowTouchMove": false,
                "slidesPerView": 4
              }
            }
          }'>
            <div class="swiper-wrapper">
              ${productListHTML}
            </div>
        </div>`;

      }
        productsContainer.innerHTML = `
        <div class="col-12 my-5 position-relative text-left d-flex align-items-center justify-content-between">
            <div class="slider-title">
                <h2 class="h3 section-title mb-0 text-capitalize">${window.globalVariables.upsell_header}</h2>
            </div>
            <div class="slider-arrows">
                <div class="upsell-swiper-button-prev swiper-button-prev icon-previous"><i class="icon-arrow-left-b"></i></div>
                <div class="upsell-swiper-button-next swiper-button-next icon-next"> <i class="icon-arrow-right-b"></i></div>
            </div>
        </div>
        <div class="col-12 text-center">
          <div class="row justify-content-center product-carousel mx-md-n3 mx-n1">
              <slider-element class="swiper-container carousel px-0">
                ${dataSliderOptions}
              </slider-element>
          </div>
        </div>`;

        const upsellDropBox = document.querySelectorAll('.upsell_container [data-upsell-dropbox]');
        upsellDropBox.forEach(dropBox => {
          dropBox.addEventListener('change', (event)=>{
            event.preventDefault();
            const currentTarget = event.currentTarget;
            const parentCard = currentTarget.closest(".card-product");
            let productID = parseInt(currentTarget.closest(".card-product").getAttribute("data-product-id"));
            let variantID = parseInt(currentTarget.value);

            let findProduct = diffJSON.find(pro => pro.product.id === productID);
            let findVariant = findProduct.product.variants.find(v => v.id === variantID);


            parentCard.querySelector("[data-upsell-btn]").setAttribute("data-addproductid",variantID);
            if(findVariant.featured_image != null)
            parentCard.querySelector(".upsell_product_image").setAttribute("src",findVariant.featured_image.src);
            parentCard.querySelector(".upsell_productRegularPrice").innerHTML = Shopify.formatMoney(findVariant.price, window.globalVariables.money_format);

          });
        });

        const addItemBtns = document.querySelectorAll('.upsell_add_button [data-upsell-btn]');
        addItemBtns.forEach(btn => {
          btn.addEventListener('click', (event)=>{

            event.preventDefault();
            const currentTarget = event.currentTarget;
            const body = JSON.stringify({
              id: currentTarget.getAttribute('data-addproductid'),
              quantity: 1
            });
            currentTarget.textContent = "Please Wait....";
            currentTarget.classList.add("disabled");
            let fetchCart = fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body }});
            fetchCart.then(response => {
                return response.json();
            }).then(data => {
                $this.getCartData();
            }).catch((e) => {
                console.error(e);
            });
          });
        });

    }

    _diff(obj1, obj2) {

      let diffrentProduct = [];
      obj1.forEach(pro => {
          let flag = false;
            obj2.forEach(item => {
                if (pro.product.id == item.product_id)
                {
                    flag = true;
                }
            });
          if(!flag) diffrentProduct.push(pro);
      });
      return diffrentProduct;

    }
}
customElements.define("ajax-cart", ajaxCart);